import React, { forwardRef, useEffect } from 'react'
import Select from 'react-select'

const CalculatorSelect = forwardRef(({ values, group, initialOption = null, title = '', onControlChange }, ref) => {
  const onSelectChange = (e) => {
    if (group === 'shape') {
      onControlChange(group, e.isRound)
    } else {
      onControlChange(group, e.value)
    }
  }

  const colors = {
    backgroundColor: {
      selected: '#DEE2E6',
      focused: '#007BFF'
    },
    textColor: {
      selected: '#212529',
      focused: '#FFFFFF'
    }
  }

  useEffect(() => {
    if (group === 'shape') {
      onControlChange(group, ref.current.getValue()[0].isRound)
    } else {
      onControlChange(group, ref.current.getValue()[0].value)
    }
  }, [])

  const selectStyles = {
    option: (styles, { isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? colors.backgroundColor.selected
          : isFocused
            ? colors.backgroundColor.focused
            : undefined,
        color: isFocused && !isSelected
          ? colors.textColor.focused
          : colors.textColor.selected
      }
    }
  }

  return (
    <div className='modal-calculator__input-item'>
      <p className='modal-calculator__input-label'>{title}</p>
      <Select
        className={'modal-calculator__select ' + (group === 'shape' ? 'modal-calculator__select--shape' : '')}
        defaultValue={initialOption || values[0]}
        name={group}
        options={values}
        onChange={onSelectChange}
        ref={ref}
        components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
        styles={selectStyles}
      />
    </div>
  )
})

export default React.memo(CalculatorSelect)
